 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import CONTENTCONTENT0007 from '@/components/content/content0007'
 import CONTENTCONTENT0008 from '@/components/content/content0008'
 import CONTENTCONTENT0010 from '@/components/content/content0010'
 import CONTENTCONTENT0011 from '@/components/content/content0011'
 import CONTENTCONTENT0012 from '@/components/content/content0012'
 import CONTENTCONTENT0013 from '@/components/content/content0013'
 import CONTENTCONTENT0014 from '@/components/content/content0014'
 import CONTENTCONTENT0015 from '@/components/content/content0015'
 import CONTENTCONTENT0016 from '@/components/content/content0016'
 import CONTENTCONTENT0017 from '@/components/content/content0017'
 import CONTENTCONTENT0034 from '@/components/content/content0034'
 import CONTENTCONTENT0035 from '@/components/content/content0035'
 import CONTENTCONTENT0036 from '@/components/content/content0036'
 import CONTENTCONTENT0037 from '@/components/content/content0037'
 import CONTENTCONTENT0038 from '@/components/content/content0038'
 import CONTENTCONTENT0039 from '@/components/content/content0039'
 import CONTENTCONTENT0040 from '@/components/content/content0040'
 import CONTENTCONTENT0057 from '@/components/content/content0057'
 import CONTENTCONTENT0059 from '@/components/content/content0059'
 import CONTENTCONTENT0060 from '@/components/content/content0060'
 import CONTENTCONTENT0061 from '@/components/content/content0061'
 import CONTENTCONTENT0063 from '@/components/content/content0063'
 import CONTENTCONTENT0066 from '@/components/content/content0066'
 import CONTENTCONTENT0069 from '@/components/content/content0069'
 import CONTENTCONTENT0070 from '@/components/content/content0070'
 import CONTENTCONTENT0088 from '@/components/content/content0088'
 import CONTENTCONTENT0092 from '@/components/content/content0092'
 import CONTENTCONTENT0094 from '@/components/content/content0094'
 import CONTENTCONTENT0095 from '@/components/content/content0095'
 import CONTENTCONTENT0096 from '@/components/content/content0096'
 import CONTENTCONTENT0098 from '@/components/content/content0098'
 import CONTENTCONTENT0113 from '@/components/content/content0113'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/content/content0007",
 			"name" : "content/content0007",
 			"component" : CONTENTCONTENT0007
 		},
 		{
 			"path" : "/content/content0008",
 			"name" : "content/content0008",
 			"component" : CONTENTCONTENT0008
 		},
 		{
 			"path" : "/content/content0010",
 			"name" : "content/content0010",
 			"component" : CONTENTCONTENT0010
 		},
 		{
 			"path" : "/content/content0011",
 			"name" : "content/content0011",
 			"component" : CONTENTCONTENT0011
 		},
 		{
 			"path" : "/content/content0012",
 			"name" : "content/content0012",
 			"component" : CONTENTCONTENT0012
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js